import React, { useState, useEffect } from 'react';
import donut from './donut';
import colors from './colors';
import { isMediaQuery } from '~/core/scripts/mediaquery-helper.js';

const SmallDonut = function(props){

  if (!props.hasOwnProperty("data") || props.data === null || !props.data.fraktionen) return "";

  var offset = 0; // 180
  var fraktionen = props.data.fraktionen.sort(function(a,b){
    return (b[props.selected]-a[props.selected]); // sort by size
  }).map(function(fr){ // calculate segments
    fr.size = ((fr[props.selected]/props.data.gesamt[props.selected])*180);
    fr.start = offset;
    offset += fr.size;
    fr.end = offset;
    fr.textanchor = (270+(fr.end-fr.size/2))*(Math.PI/180);
    fr.textpos = ((fr.end-fr.size/2)<=75)?'end':((fr.end-fr.size/2)>=105)?'start':'middle';
    return fr;
  });
  
  var scale = isMediaQuery(500) ? 1 : (140/240);
  var fontsize = isMediaQuery(500) ? 12 : 11;
  function s(v){
    return v*scale;
  }

  return (
    <div className="donut__wrap small">
      <div className="donut">
        <svg width={s(240)} height={s(120)} viewBox={"0 0 "+s(240)+" "+s(120)}>
          <g stroke="#000" strokeWidth="0.1">
            {fraktionen.filter(function(f){
              return (f[props.selected] > 0);
            }).map(function(f){
              return (
                <>
                <path key={props.data.parlament+"-"+f.label} d={donut(s(120), s(120), s(50), s(100), f.start, f.end)} fill={colors.bar[f.gruppe]} />
                <text key={props.data.parlament+"-"+f.label+"-seats"} textAnchor={f.textpos} x={s(120+Math.sin(f.textanchor)*105)} y={(Math.round(f.end)===180)?s(120):s(120-Math.cos(f.textanchor)*105)} style={{ fill: colors.label[f.gruppe], fontSize: fontsize+'px' }} className="label label_perc">{f[props.selected]}</text>
                </>
              )
            })}
          </g>
          <line x1={s(120)} x2={s(120)} y1={s(15)} y2={s(75)} style={{ stroke: '#666666', opacity: '0.5', strokeWidth: '1' }} />
          <text textAnchor="middle" x={s(120)} y={s(75)+fontsize} style={{ color: '#666666', opacity: '0.5', fontSize: fontsize+'px' }} className="label label_50">50%</text>
        </svg>
      </div>
      <div className="info">
        <div className="info__name">{props.data.parlament}</div>
        <div className="info__stats">
          {(props.selected === "total") && (
            <div className="info__stats-seats">{props.data.gesamt.total} Sitze</div>
          )}
          {(props.selected !== "total") && (
            <>
              <div className="info__stats-seats"><strong>{props.data.gesamt[props.selected]}</strong> von <strong>{props.data.gesamt.total}</strong> Sitzen</div>
              <div className="info__stats-share">
                {(props.selected === "female") && (
                  <>Frauenanteil&nbsp;</>
                )}
                {(props.selected === "male") && (
                  <>Männeranteil&nbsp;</>
                )}
                <strong>{((props.data.gesamt[props.selected]/props.data.gesamt.total)*100).toFixed(1).replace(".",",")}</strong>%
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

/*

*/

export default SmallDonut;
